var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01677 10.2611C1.90328 10.0814 1.84654 9.99153 1.81477 9.85295C1.79091 9.74885 1.79091 9.58468 1.81477 9.48059C1.84654 9.342 1.90328 9.25215 2.01677 9.07245C2.95461 7.58747 5.74617 3.83344 10.0003 3.83344C14.2545 3.83344 17.0461 7.58747 17.9839 9.07245C18.0974 9.25215 18.1541 9.342 18.1859 9.48059C18.2098 9.58468 18.2098 9.74885 18.1859 9.85295C18.1541 9.99153 18.0974 10.0814 17.9839 10.2611C17.0461 11.7461 14.2545 15.5001 10.0003 15.5001C5.74617 15.5001 2.95461 11.7461 2.01677 10.2611Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12.1668C11.381 12.1668 12.5003 11.0475 12.5003 9.66677C12.5003 8.28606 11.381 7.16677 10.0003 7.16677C8.61962 7.16677 7.50034 8.28606 7.50034 9.66677C7.50034 11.0475 8.61962 12.1668 10.0003 12.1668Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.333435d8f7c69d6799a5aa8a8a3423e7.svg";
export { ForwardRef as ReactComponent };